import axios from "axios";
import store from "@/store";
import { setupResponseInterceptor } from './responseInterceptor';

const resilienceConsultationClient = axios.create({
  baseURL: process.env.VUE_APP_RESILIENCE_CONSULTATION_URL,
  withCredentials: true,
});

resilienceConsultationClient.interceptors.request.use((config) => {
  config.headers.lang = store.getters["getLang"];
  return config;
});

setupResponseInterceptor(resilienceConsultationClient);

export default resilienceConsultationClient;